import { log } from "@grafit/shared/observability/sentry-front";

let sentSizeLog = false;
function updateRootFontSize() {
  let base = 16;
  const innerWidth = window.innerWidth;
  if (innerWidth < 1400) {
    base = 15;
  }
  if (innerWidth < 1300) {
    base = 14;
  }
  if (innerWidth < 1220) {
    base = 13;
  }
  if (innerWidth < 1150) {
    base = 12;
  }
  if (innerWidth < 1000 && !sentSizeLog) {
    sentSizeLog = true;
    const isAutomatedBrowser = navigator.webdriver;
    if (isAutomatedBrowser) {
      return;
    }

    log(`Application rendered outside minimal bounds, did not expected a size < 1000: ${innerWidth}`, "info");
  }
  document.documentElement.style.fontSize = `${base}px`;
}
window.addEventListener("resize", updateRootFontSize);
updateRootFontSize();
